/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssessmentCreateRequest,
  AssessmentProgressResponse,
  AssessmentResultResponse,
  AssessmentSummaryResponse,
  AssessmentUpdateRequest,
  BudgetSummaryResponse,
  CatalogComparisonResponse,
  ControlListResponse,
  ControlResponse,
  DashboardResponse,
  FindingCreateRequest,
  FindingDto,
  FindingsSummaryResponse,
  FunctionMaturityResponse,
  GroupListResponse,
  GroupListWithCountsResponse,
  GroupResponse,
  NistCSFProfileCreateRequest,
  NistCsfWizardCatalogTreeResponse,
  OverallMaturityResponse,
  ProfileDto,
  ProfileListResponse,
  ProfileResolutionResponse,
  ProfileSSPResponse,
  RecentActivityResponse,
  RemediationSummaryResponse,
  ResultResponse,
  ResultUpdateRequest,
  SspControlsGroupedResponse,
} from '../models/index';
import {
    AssessmentCreateRequestFromJSON,
    AssessmentCreateRequestToJSON,
    AssessmentProgressResponseFromJSON,
    AssessmentProgressResponseToJSON,
    AssessmentResultResponseFromJSON,
    AssessmentResultResponseToJSON,
    AssessmentSummaryResponseFromJSON,
    AssessmentSummaryResponseToJSON,
    AssessmentUpdateRequestFromJSON,
    AssessmentUpdateRequestToJSON,
    BudgetSummaryResponseFromJSON,
    BudgetSummaryResponseToJSON,
    CatalogComparisonResponseFromJSON,
    CatalogComparisonResponseToJSON,
    ControlListResponseFromJSON,
    ControlListResponseToJSON,
    ControlResponseFromJSON,
    ControlResponseToJSON,
    DashboardResponseFromJSON,
    DashboardResponseToJSON,
    FindingCreateRequestFromJSON,
    FindingCreateRequestToJSON,
    FindingDtoFromJSON,
    FindingDtoToJSON,
    FindingsSummaryResponseFromJSON,
    FindingsSummaryResponseToJSON,
    FunctionMaturityResponseFromJSON,
    FunctionMaturityResponseToJSON,
    GroupListResponseFromJSON,
    GroupListResponseToJSON,
    GroupListWithCountsResponseFromJSON,
    GroupListWithCountsResponseToJSON,
    GroupResponseFromJSON,
    GroupResponseToJSON,
    NistCSFProfileCreateRequestFromJSON,
    NistCSFProfileCreateRequestToJSON,
    NistCsfWizardCatalogTreeResponseFromJSON,
    NistCsfWizardCatalogTreeResponseToJSON,
    OverallMaturityResponseFromJSON,
    OverallMaturityResponseToJSON,
    ProfileDtoFromJSON,
    ProfileDtoToJSON,
    ProfileListResponseFromJSON,
    ProfileListResponseToJSON,
    ProfileResolutionResponseFromJSON,
    ProfileResolutionResponseToJSON,
    ProfileSSPResponseFromJSON,
    ProfileSSPResponseToJSON,
    RecentActivityResponseFromJSON,
    RecentActivityResponseToJSON,
    RemediationSummaryResponseFromJSON,
    RemediationSummaryResponseToJSON,
    ResultResponseFromJSON,
    ResultResponseToJSON,
    ResultUpdateRequestFromJSON,
    ResultUpdateRequestToJSON,
    SspControlsGroupedResponseFromJSON,
    SspControlsGroupedResponseToJSON,
} from '../models/index';

export interface CreateAssessmentForSSPRequest {
    sspId: string;
    assessmentCreateRequest: AssessmentCreateRequest;
}

export interface CreateFindingRequest {
    assessmentId: string;
    resultId: string;
    findingCreateRequest: FindingCreateRequest;
}

export interface CreateProfile1Request {
    nistCSFProfileCreateRequest: NistCSFProfileCreateRequest;
}

export interface DeleteAssessmentRequest {
    assessmentId: string;
}

export interface DeleteFindingRequest {
    assessmentId: string;
    resultId: string;
}

export interface GetAllAssessmentsBySSPIdRequest {
    sspId: string;
}

export interface GetAssessedControlIdsRequest {
    sspId: string;
}

export interface GetAssessmentByIdRequest {
    assessmentId: string;
}

export interface GetAssessmentBySSPIdRequest {
    sspId: string;
}

export interface GetAssessmentProgressRequest {
    sspId: string;
    assessmentId?: string;
}

export interface GetAssessmentsSummaryRequest {
    sspId: string;
    assessmentIds?: Array<string>;
}

export interface GetBaseCatalogWithSelectionsRequest {
    profileId: string;
}

export interface GetBudgetSummaryRequest {
    sspId: string;
}

export interface GetCategoriesByFunctionIdRequest {
    functionId: string;
}

export interface GetCategoriesByFunctionIdForSSPRequest {
    sspId: string;
    functionId: string;
}

export interface GetCategoriesByFunctionIdResolvedWithCountsRequest {
    functionId: string;
}

export interface GetControlByControlIdRequest {
    controlId: string;
}

export interface GetControlByControlIdForSSPRequest {
    sspId: string;
    controlId: string;
}

export interface GetControlByControlIdResolvedRequest {
    controlId: string;
}

export interface GetControlsByGroupIdRequest {
    groupId: string;
    page?: string;
    pageSize?: string;
}

export interface GetControlsByGroupIdForSSPRequest {
    sspId: string;
    groupId: string;
    page?: string;
    pageSize?: string;
}

export interface GetControlsByGroupIdResolvedRequest {
    groupId: string;
    page?: string;
    pageSize?: string;
}

export interface GetControlsGroupedByFunctionCategoryRequest {
    sspId: string;
    page?: string;
    pageSize?: string;
}

export interface GetFindingsSummaryRequest {
    sspId: string;
    assessmentId?: string;
}

export interface GetFunctionMaturityRequest {
    sspId: string;
    assessmentId?: string;
}

export interface GetGroupByIdRequest {
    groupId: string;
}

export interface GetGroupHierarchyRequest {
    groupId: string;
}

export interface GetNistCsfDashboardRequest {
    sspId: string;
    assessmentId?: string;
}

export interface GetOverallMaturityRequest {
    sspId: string;
    assessmentId?: string;
}

export interface GetProfileById1Request {
    id: string;
}

export interface GetProfilesRequest {
    page?: string;
    pageSize?: string;
}

export interface GetRecentActivityRequest {
    sspId: string;
    assessmentId?: string;
    limit?: number;
}

export interface GetRemediationSummaryRequest {
    sspId: string;
}

export interface GetSSPForProfileRequest {
    profileId: string;
}

export interface GetStatementForControlRequest {
    sspId: string;
    controlId: string;
}

export interface ResolveProfile1Request {
    id: string;
    resolvedBy?: string;
}

export interface SearchGroupsRequest {
    q: string;
    page?: string;
    pageSize?: string;
}

export interface SearchGroupsResolvedRequest {
    q: string;
    page?: string;
    pageSize?: string;
}

export interface UpdateAssessmentRequest {
    assessmentId: string;
    assessmentUpdateRequest: AssessmentUpdateRequest;
}

export interface UpdateResultPropertiesRequest {
    assessmentId: string;
    resultId: string;
    resultUpdateRequest: ResultUpdateRequest;
}

export interface UpdateStatementForControlRequest {
    sspId: string;
    controlId: string;
    body: string;
}

/**
 * NISTCSFApi - interface
 * 
 * @export
 * @interface NISTCSFApiInterface
 */
export interface NISTCSFApiInterface {
    /**
     * Creates an AssessmentResults document for a System Security Plan. Can assess specific controls, all controls in specified groups (recursively), or all controls in the SSP.
     * @summary Create assessment for SSP
     * @param {string} sspId SSP UUID
     * @param {AssessmentCreateRequest} assessmentCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    createAssessmentForSSPRaw(requestParameters: CreateAssessmentForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>>;

    /**
     * Creates an AssessmentResults document for a System Security Plan. Can assess specific controls, all controls in specified groups (recursively), or all controls in the SSP.
     * Create assessment for SSP
     */
    createAssessmentForSSP(requestParameters: CreateAssessmentForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object>;

    /**
     * Creates a finding associated with a result. The assessment status will be calculated based on maturity levels if not provided.
     * @summary Create a finding for an assessment result
     * @param {string} assessmentId Assessment UUID
     * @param {string} resultId Result UUID
     * @param {FindingCreateRequest} findingCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    createFindingRaw(requestParameters: CreateFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingDto>>;

    /**
     * Creates a finding associated with a result. The assessment status will be calculated based on maturity levels if not provided.
     * Create a finding for an assessment result
     */
    createFinding(requestParameters: CreateFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingDto>;

    /**
     * Creates a new profile that imports the NIST CSF 2.0 BASE catalog. The profile can optionally include control selections, exclusions, and modifications.
     * @summary Create NIST CSF profile
     * @param {NistCSFProfileCreateRequest} nistCSFProfileCreateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    createProfile1Raw(requestParameters: CreateProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDto>>;

    /**
     * Creates a new profile that imports the NIST CSF 2.0 BASE catalog. The profile can optionally include control selections, exclusions, and modifications.
     * Create NIST CSF profile
     */
    createProfile1(requestParameters: CreateProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDto>;

    /**
     * Deletes an AssessmentResults document by its UUID. This will also delete all associated results and related entities.
     * @summary Delete assessment
     * @param {string} assessmentId Assessment UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    deleteAssessmentRaw(requestParameters: DeleteAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes an AssessmentResults document by its UUID. This will also delete all associated results and related entities.
     * Delete assessment
     */
    deleteAssessment(requestParameters: DeleteAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Deletes the finding associated with a result.
     * @summary Delete a finding for an assessment result
     * @param {string} assessmentId Assessment UUID
     * @param {string} resultId Result UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    deleteFindingRaw(requestParameters: DeleteFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Deletes the finding associated with a result.
     * Delete a finding for an assessment result
     */
    deleteFinding(requestParameters: DeleteFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Retrieves all AssessmentResults documents for a System Security Plan. Returns a list of all assessments with their results and CMMI maturity levels.
     * @summary Get all assessments for SSP
     * @param {string} sspId SSP UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAllAssessmentsBySSPIdRaw(requestParameters: GetAllAssessmentsBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssessmentResultResponse>>>;

    /**
     * Retrieves all AssessmentResults documents for a System Security Plan. Returns a list of all assessments with their results and CMMI maturity levels.
     * Get all assessments for SSP
     */
    getAllAssessmentsBySSPId(requestParameters: GetAllAssessmentsBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssessmentResultResponse>>;

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the NIST CSF 2.0 catalog
     * @summary Get all functions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAllFunctionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the NIST CSF 2.0 catalog
     * Get all functions
     */
    getAllFunctions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the resolved NIST CSF 2.0 catalog. Resolved catalogs are created from profiles and contain tailored controls.
     * @summary Get all functions from resolved catalog
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAllFunctionsResolvedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the resolved NIST CSF 2.0 catalog. Resolved catalogs are created from profiles and contain tailored controls.
     * Get all functions from resolved catalog
     */
    getAllFunctionsResolved(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Retrieves all control IDs that are already assessed in existing assessments for a System Security Plan. This is used to filter out controls when creating a new assessment to prevent duplicate assessments.
     * @summary Get assessed control IDs for SSP
     * @param {string} sspId SSP UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAssessedControlIdsRaw(requestParameters: GetAssessedControlIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>>;

    /**
     * Retrieves all control IDs that are already assessed in existing assessments for a System Security Plan. This is used to filter out controls when creating a new assessment to prevent duplicate assessments.
     * Get assessed control IDs for SSP
     */
    getAssessedControlIds(requestParameters: GetAssessedControlIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>>;

    /**
     * Retrieves an AssessmentResults document by its UUID. Includes all results with their CMMI maturity levels.
     * @summary Get assessment by ID
     * @param {string} assessmentId Assessment UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAssessmentByIdRaw(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>>;

    /**
     * Retrieves an AssessmentResults document by its UUID. Includes all results with their CMMI maturity levels.
     * Get assessment by ID
     */
    getAssessmentById(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse>;

    /**
     * Retrieves the AssessmentResults document for a System Security Plan. Includes all results with their CMMI maturity levels.
     * @summary Get assessment for SSP
     * @param {string} sspId SSP UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAssessmentBySSPIdRaw(requestParameters: GetAssessmentBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>>;

    /**
     * Retrieves the AssessmentResults document for a System Security Plan. Includes all results with their CMMI maturity levels.
     * Get assessment for SSP
     */
    getAssessmentBySSPId(requestParameters: GetAssessmentBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse>;

    /**
     * Percentage of control results with a maturity set (0-100).
     * @summary Get assessment progress
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAssessmentProgressRaw(requestParameters: GetAssessmentProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentProgressResponse>>;

    /**
     * Percentage of control results with a maturity set (0-100).
     * Get assessment progress
     */
    getAssessmentProgress(requestParameters: GetAssessmentProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentProgressResponse>;

    /**
     * Lightweight list of assessments (id, name) for the Assessment dropdown.
     * @summary Get assessments summary for dashboard filter
     * @param {string} sspId SSP UUID
     * @param {Array<string>} [assessmentIds] Optional list of assessment IDs to restrict results
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getAssessmentsSummaryRaw(requestParameters: GetAssessmentsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentSummaryResponse>>;

    /**
     * Lightweight list of assessments (id, name) for the Assessment dropdown.
     * Get assessments summary for dashboard filter
     */
    getAssessmentsSummary(requestParameters: GetAssessmentsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentSummaryResponse>;

    /**
     * Returns the full base NIST CSF 2.0 catalog structure (groups and controls) with flags indicating which items were selected in the resolved catalog built from the specified profile.
     * @summary Get base catalog with selection indicators
     * @param {string} profileId Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getBaseCatalogWithSelectionsRaw(requestParameters: GetBaseCatalogWithSelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogComparisonResponse>>;

    /**
     * Returns the full base NIST CSF 2.0 catalog structure (groups and controls) with flags indicating which items were selected in the resolved catalog built from the specified profile.
     * Get base catalog with selection indicators
     */
    getBaseCatalogWithSelections(requestParameters: GetBaseCatalogWithSelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogComparisonResponse>;

    /**
     * Total budget from POAMs and total allocated from POAM item milestones.
     * @summary Get budget summary
     * @param {string} sspId SSP UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getBudgetSummaryRaw(requestParameters: GetBudgetSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BudgetSummaryResponse>>;

    /**
     * Total budget from POAMs and total allocated from POAM item milestones.
     * Get budget summary
     */
    getBudgetSummary(requestParameters: GetBudgetSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BudgetSummaryResponse>;

    /**
     * Retrieves all categories (sub-groups) for a specific function
     * @summary Get categories for a function
     * @param {string} functionId Function group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getCategoriesByFunctionIdRaw(requestParameters: GetCategoriesByFunctionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Retrieves all categories (sub-groups) for a specific function
     * Get categories for a function
     */
    getCategoriesByFunctionId(requestParameters: GetCategoriesByFunctionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. Includes control counts for each category.
     * @summary Get categories for a function from SSP
     * @param {string} sspId SSP UUID
     * @param {string} functionId Function group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getCategoriesByFunctionIdForSSPRaw(requestParameters: GetCategoriesByFunctionIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListWithCountsResponse>>;

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. Includes control counts for each category.
     * Get categories for a function from SSP
     */
    getCategoriesByFunctionIdForSSP(requestParameters: GetCategoriesByFunctionIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListWithCountsResponse>;

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved NIST CSF 2.0 catalog. Includes control counts for each category.
     * @summary Get categories for a function from resolved catalog with control counts
     * @param {string} functionId Function group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getCategoriesByFunctionIdResolvedWithCountsRaw(requestParameters: GetCategoriesByFunctionIdResolvedWithCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListWithCountsResponse>>;

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved NIST CSF 2.0 catalog. Includes control counts for each category.
     * Get categories for a function from resolved catalog with control counts
     */
    getCategoriesByFunctionIdResolvedWithCounts(requestParameters: GetCategoriesByFunctionIdResolvedWithCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListWithCountsResponse>;

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\')
     * @summary Get control by control ID
     * @param {string} controlId Control ID (e.g., \&#39;gv.oc-1\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlByControlIdRaw(requestParameters: GetControlByControlIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>>;

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\')
     * Get control by control ID
     */
    getControlByControlId(requestParameters: GetControlByControlIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse>;

    /**
     * Retrieves a specific control by its control ID from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. This ensures the correct control is returned even if the same controlId exists in multiple catalogs.
     * @summary Get control by control ID from SSP
     * @param {string} sspId SSP UUID
     * @param {string} controlId Control ID (e.g., \&#39;gv.oc-1\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlByControlIdForSSPRaw(requestParameters: GetControlByControlIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>>;

    /**
     * Retrieves a specific control by its control ID from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. This ensures the correct control is returned even if the same controlId exists in multiple catalogs.
     * Get control by control ID from SSP
     */
    getControlByControlIdForSSP(requestParameters: GetControlByControlIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse>;

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\') from the resolved NIST CSF 2.0 catalog. The control must belong to a resolved catalog.
     * @summary Get control by control ID from resolved catalog
     * @param {string} controlId Control ID (e.g., \&#39;gv.oc-1\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlByControlIdResolvedRaw(requestParameters: GetControlByControlIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>>;

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\') from the resolved NIST CSF 2.0 catalog. The control must belong to a resolved catalog.
     * Get control by control ID from resolved catalog
     */
    getControlByControlIdResolved(requestParameters: GetControlByControlIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse>;

    /**
     * Retrieves paginated controls for a specific group
     * @summary Get controls for a group
     * @param {string} groupId Group ID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlsByGroupIdRaw(requestParameters: GetControlsByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>>;

    /**
     * Retrieves paginated controls for a specific group
     * Get controls for a group
     */
    getControlsByGroupId(requestParameters: GetControlsByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse>;

    /**
     * Retrieves paginated controls for a specific group from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id.
     * @summary Get controls for a group from SSP
     * @param {string} sspId SSP UUID
     * @param {string} groupId Group ID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlsByGroupIdForSSPRaw(requestParameters: GetControlsByGroupIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>>;

    /**
     * Retrieves paginated controls for a specific group from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id.
     * Get controls for a group from SSP
     */
    getControlsByGroupIdForSSP(requestParameters: GetControlsByGroupIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse>;

    /**
     * Retrieves paginated controls for a specific group from the resolved NIST CSF 2.0 catalog. The group must belong to a resolved catalog.
     * @summary Get controls for a group from resolved catalog
     * @param {string} groupId Group ID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlsByGroupIdResolvedRaw(requestParameters: GetControlsByGroupIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>>;

    /**
     * Retrieves paginated controls for a specific group from the resolved NIST CSF 2.0 catalog. The group must belong to a resolved catalog.
     * Get controls for a group from resolved catalog
     */
    getControlsByGroupIdResolved(requestParameters: GetControlsByGroupIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse>;

    /**
     * Retrieves controls for an SSP grouped by function and category, paginated by function. Each page returns one or more functions with all their categories and controls from the SSP\'s resolved catalog.
     * @summary Get controls grouped by function and category for SSP
     * @param {string} sspId SSP UUID
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getControlsGroupedByFunctionCategoryRaw(requestParameters: GetControlsGroupedByFunctionCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SspControlsGroupedResponse>>;

    /**
     * Retrieves controls for an SSP grouped by function and category, paginated by function. Each page returns one or more functions with all their categories and controls from the SSP\'s resolved catalog.
     * Get controls grouped by function and category for SSP
     */
    getControlsGroupedByFunctionCategory(requestParameters: GetControlsGroupedByFunctionCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SspControlsGroupedResponse>;

    /**
     * Counts of satisfied and not-satisfied findings in scoped results.
     * @summary Get findings summary
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getFindingsSummaryRaw(requestParameters: GetFindingsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingsSummaryResponse>>;

    /**
     * Counts of satisfied and not-satisfied findings in scoped results.
     * Get findings summary
     */
    getFindingsSummary(requestParameters: GetFindingsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingsSummaryResponse>;

    /**
     * Maturity and progress per CSF function (GV, ID, PR, DE, RS, RC) for overview cards and spider chart.
     * @summary Get function maturity
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID to scope to one assessment
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getFunctionMaturityRaw(requestParameters: GetFunctionMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionMaturityResponse>>;

    /**
     * Maturity and progress per CSF function (GV, ID, PR, DE, RS, RC) for overview cards and spider chart.
     * Get function maturity
     */
    getFunctionMaturity(requestParameters: GetFunctionMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionMaturityResponse>;

    /**
     * Retrieves a specific group with its basic details
     * @summary Get group details
     * @param {string} groupId Group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getGroupByIdRaw(requestParameters: GetGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Retrieves a specific group with its basic details
     * Get group details
     */
    getGroupById(requestParameters: GetGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * Retrieves a group with its full hierarchy including sub-groups and controls
     * @summary Get group hierarchy
     * @param {string} groupId Group ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getGroupHierarchyRaw(requestParameters: GetGroupHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>>;

    /**
     * Retrieves a group with its full hierarchy including sub-groups and controls
     * Get group hierarchy
     */
    getGroupHierarchy(requestParameters: GetGroupHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse>;

    /**
     * All dashboard widget data in one response.
     * @summary Get combined dashboard
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getNistCsfDashboardRaw(requestParameters: GetNistCsfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardResponse>>;

    /**
     * All dashboard widget data in one response.
     * Get combined dashboard
     */
    getNistCsfDashboard(requestParameters: GetNistCsfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardResponse>;

    /**
     * Average current maturity (1-5) across scoped assessment results.
     * @summary Get overall maturity
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getOverallMaturityRaw(requestParameters: GetOverallMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverallMaturityResponse>>;

    /**
     * Average current maturity (1-5) across scoped assessment results.
     * Get overall maturity
     */
    getOverallMaturity(requestParameters: GetOverallMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverallMaturityResponse>;

    /**
     * Retrieves a specific profile by its UUID that imports the NIST CSF 2.0 BASE catalog.
     * @summary Get NIST CSF profile by ID
     * @param {string} id Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getProfileById1Raw(requestParameters: GetProfileById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDto>>;

    /**
     * Retrieves a specific profile by its UUID that imports the NIST CSF 2.0 BASE catalog.
     * Get NIST CSF profile by ID
     */
    getProfileById1(requestParameters: GetProfileById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDto>;

    /**
     * Retrieves a paginated list of all profiles that import the NIST CSF 2.0 BASE catalog.
     * @summary Get all NIST CSF profiles
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getProfilesRaw(requestParameters: GetProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>>;

    /**
     * Retrieves a paginated list of all profiles that import the NIST CSF 2.0 BASE catalog.
     * Get all NIST CSF profiles
     */
    getProfiles(requestParameters: GetProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse>;

    /**
     * Merged assessment and POAM events for this SSP, sorted by date descending.
     * @summary Get recent activity
     * @param {string} sspId SSP UUID
     * @param {string} [assessmentId] Optional assessment ID to filter activity
     * @param {number} [limit] Max number of items
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getRecentActivityRaw(requestParameters: GetRecentActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentActivityResponse>>;

    /**
     * Merged assessment and POAM events for this SSP, sorted by date descending.
     * Get recent activity
     */
    getRecentActivity(requestParameters: GetRecentActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentActivityResponse>;

    /**
     * Open POAM count and overdue POAM item count for this SSP.
     * @summary Get remediation summary
     * @param {string} sspId SSP UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getRemediationSummaryRaw(requestParameters: GetRemediationSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemediationSummaryResponse>>;

    /**
     * Open POAM count and overdue POAM item count for this SSP.
     * Get remediation summary
     */
    getRemediationSummary(requestParameters: GetRemediationSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemediationSummaryResponse>;

    /**
     * Retrieves the System Security Plan ID and assessment IDs associated with a profile. This provides a direct way to get the SSP ID without re-resolving the profile.
     * @summary Get SSP and assessments for profile
     * @param {string} profileId Profile UUID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getSSPForProfileRaw(requestParameters: GetSSPForProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileSSPResponse>>;

    /**
     * Retrieves the System Security Plan ID and assessment IDs associated with a profile. This provides a direct way to get the SSP ID without re-resolving the profile.
     * Get SSP and assessments for profile
     */
    getSSPForProfile(requestParameters: GetSSPForProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileSSPResponse>;

    /**
     * Retrieves the statement description for a control in an SSP\'s ImplementedRequirement.
     * @summary Get statement for control in SSP
     * @param {string} sspId SSP UUID
     * @param {string} controlId Control ID (e.g., \&#39;gv.oc-1\&#39;)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getStatementForControlRaw(requestParameters: GetStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>>;

    /**
     * Retrieves the statement description for a control in an SSP\'s ImplementedRequirement.
     * Get statement for control in SSP
     */
    getStatementForControl(requestParameters: GetStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string>;

    /**
     * Returns the full NIST CSF 2.0 BASE catalog as nested functions, categories, and slim control rows (id, controlId, title, targetMaturity) in one response. Replaces many parallel calls to functions, categories, and per-group controls for the wizard.
     * @summary Get BASE catalog tree for create/tailor wizard
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    getWizardBaseCatalogTreeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NistCsfWizardCatalogTreeResponse>>;

    /**
     * Returns the full NIST CSF 2.0 BASE catalog as nested functions, categories, and slim control rows (id, controlId, title, targetMaturity) in one response. Replaces many parallel calls to functions, categories, and per-group controls for the wizard.
     * Get BASE catalog tree for create/tailor wizard
     */
    getWizardBaseCatalogTree(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NistCsfWizardCatalogTreeResponse>;

    /**
     * Resolves a NIST CSF profile to generate a resolved catalog. The resolved catalog contains tailored controls based on the profile\'s selections, exclusions, and modifications.
     * @summary Resolve profile to catalog
     * @param {string} id Profile UUID
     * @param {string} [resolvedBy] User or system performing the resolution
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    resolveProfile1Raw(requestParameters: ResolveProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>>;

    /**
     * Resolves a NIST CSF profile to generate a resolved catalog. The resolved catalog contains tailored controls based on the profile\'s selections, exclusions, and modifications.
     * Resolve profile to catalog
     */
    resolveProfile1(requestParameters: ResolveProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse>;

    /**
     * Searches groups by title or description with pagination
     * @summary Search groups
     * @param {string} q Search term
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    searchGroupsRaw(requestParameters: SearchGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Searches groups by title or description with pagination
     * Search groups
     */
    searchGroups(requestParameters: SearchGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Searches groups by title or description with pagination in the resolved NIST CSF 2.0 catalog. Resolved catalogs contain controls that have been tailored and customized from profiles.
     * @summary Search groups in resolved catalog
     * @param {string} q Search term
     * @param {string} [page] 
     * @param {string} [pageSize] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    searchGroupsResolvedRaw(requestParameters: SearchGroupsResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>>;

    /**
     * Searches groups by title or description with pagination in the resolved NIST CSF 2.0 catalog. Resolved catalogs contain controls that have been tailored and customized from profiles.
     * Search groups in resolved catalog
     */
    searchGroupsResolved(requestParameters: SearchGroupsResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse>;

    /**
     * Adds new controls to an existing assessment. Can add specific controls or all controls in specified groups (recursively). Controls that are already in the assessment will be skipped.
     * @summary Update assessment to add controls
     * @param {string} assessmentId Assessment UUID
     * @param {AssessmentUpdateRequest} assessmentUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    updateAssessmentRaw(requestParameters: UpdateAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>>;

    /**
     * Adds new controls to an existing assessment. Can add specific controls or all controls in specified groups (recursively). Controls that are already in the assessment will be skipped.
     * Update assessment to add controls
     */
    updateAssessment(requestParameters: UpdateAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse>;

    /**
     * Updates the current CMMI maturity level for a specific assessment result. Target maturity is defined on the catalog control. CMMI maturity values must be integers between 1 and 5 (inclusive).
     * @summary Update result properties
     * @param {string} assessmentId Assessment UUID
     * @param {string} resultId Result UUID
     * @param {ResultUpdateRequest} resultUpdateRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    updateResultPropertiesRaw(requestParameters: UpdateResultPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultResponse>>;

    /**
     * Updates the current CMMI maturity level for a specific assessment result. Target maturity is defined on the catalog control. CMMI maturity values must be integers between 1 and 5 (inclusive).
     * Update result properties
     */
    updateResultProperties(requestParameters: UpdateResultPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultResponse>;

    /**
     * Updates the statement description for a control in an SSP\'s ImplementedRequirement. Creates the ImplementedRequirement and Statement if they don\'t exist.
     * @summary Update statement for control in SSP
     * @param {string} sspId SSP UUID
     * @param {string} controlId Control ID (e.g., \&#39;gv.oc-1\&#39;)
     * @param {string} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof NISTCSFApiInterface
     */
    updateStatementForControlRaw(requestParameters: UpdateStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Updates the statement description for a control in an SSP\'s ImplementedRequirement. Creates the ImplementedRequirement and Statement if they don\'t exist.
     * Update statement for control in SSP
     */
    updateStatementForControl(requestParameters: UpdateStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class NISTCSFApi extends runtime.BaseAPI implements NISTCSFApiInterface {

    /**
     * Creates an AssessmentResults document for a System Security Plan. Can assess specific controls, all controls in specified groups (recursively), or all controls in the SSP.
     * Create assessment for SSP
     */
    async createAssessmentForSSPRaw(requestParameters: CreateAssessmentForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<object>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling createAssessmentForSSP().'
            );
        }

        if (requestParameters['assessmentCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'assessmentCreateRequest',
                'Required parameter "assessmentCreateRequest" was null or undefined when calling createAssessmentForSSP().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/assessment`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AssessmentCreateRequestToJSON(requestParameters['assessmentCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Creates an AssessmentResults document for a System Security Plan. Can assess specific controls, all controls in specified groups (recursively), or all controls in the SSP.
     * Create assessment for SSP
     */
    async createAssessmentForSSP(requestParameters: CreateAssessmentForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<object> {
        const response = await this.createAssessmentForSSPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a finding associated with a result. The assessment status will be calculated based on maturity levels if not provided.
     * Create a finding for an assessment result
     */
    async createFindingRaw(requestParameters: CreateFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingDto>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling createFinding().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling createFinding().'
            );
        }

        if (requestParameters['findingCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'findingCreateRequest',
                'Required parameter "findingCreateRequest" was null or undefined when calling createFinding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}/result/{resultId}/finding`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));
        urlPath = urlPath.replace(`{${"resultId"}}`, encodeURIComponent(String(requestParameters['resultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindingCreateRequestToJSON(requestParameters['findingCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingDtoFromJSON(jsonValue));
    }

    /**
     * Creates a finding associated with a result. The assessment status will be calculated based on maturity levels if not provided.
     * Create a finding for an assessment result
     */
    async createFinding(requestParameters: CreateFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingDto> {
        const response = await this.createFindingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new profile that imports the NIST CSF 2.0 BASE catalog. The profile can optionally include control selections, exclusions, and modifications.
     * Create NIST CSF profile
     */
    async createProfile1Raw(requestParameters: CreateProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDto>> {
        if (requestParameters['nistCSFProfileCreateRequest'] == null) {
            throw new runtime.RequiredError(
                'nistCSFProfileCreateRequest',
                'Required parameter "nistCSFProfileCreateRequest" was null or undefined when calling createProfile1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/profile`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: NistCSFProfileCreateRequestToJSON(requestParameters['nistCSFProfileCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileDtoFromJSON(jsonValue));
    }

    /**
     * Creates a new profile that imports the NIST CSF 2.0 BASE catalog. The profile can optionally include control selections, exclusions, and modifications.
     * Create NIST CSF profile
     */
    async createProfile1(requestParameters: CreateProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDto> {
        const response = await this.createProfile1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an AssessmentResults document by its UUID. This will also delete all associated results and related entities.
     * Delete assessment
     */
    async deleteAssessmentRaw(requestParameters: DeleteAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling deleteAssessment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes an AssessmentResults document by its UUID. This will also delete all associated results and related entities.
     * Delete assessment
     */
    async deleteAssessment(requestParameters: DeleteAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteAssessmentRaw(requestParameters, initOverrides);
    }

    /**
     * Deletes the finding associated with a result.
     * Delete a finding for an assessment result
     */
    async deleteFindingRaw(requestParameters: DeleteFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling deleteFinding().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling deleteFinding().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}/result/{resultId}/finding`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));
        urlPath = urlPath.replace(`{${"resultId"}}`, encodeURIComponent(String(requestParameters['resultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Deletes the finding associated with a result.
     * Delete a finding for an assessment result
     */
    async deleteFinding(requestParameters: DeleteFindingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFindingRaw(requestParameters, initOverrides);
    }

    /**
     * Retrieves all AssessmentResults documents for a System Security Plan. Returns a list of all assessments with their results and CMMI maturity levels.
     * Get all assessments for SSP
     */
    async getAllAssessmentsBySSPIdRaw(requestParameters: GetAllAssessmentsBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<AssessmentResultResponse>>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getAllAssessmentsBySSPId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/assessments`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(AssessmentResultResponseFromJSON));
    }

    /**
     * Retrieves all AssessmentResults documents for a System Security Plan. Returns a list of all assessments with their results and CMMI maturity levels.
     * Get all assessments for SSP
     */
    async getAllAssessmentsBySSPId(requestParameters: GetAllAssessmentsBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<AssessmentResultResponse>> {
        const response = await this.getAllAssessmentsBySSPIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the NIST CSF 2.0 catalog
     * Get all functions
     */
    async getAllFunctionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/functions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the NIST CSF 2.0 catalog
     * Get all functions
     */
    async getAllFunctions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.getAllFunctionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the resolved NIST CSF 2.0 catalog. Resolved catalogs are created from profiles and contain tailored controls.
     * Get all functions from resolved catalog
     */
    async getAllFunctionsResolvedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/functions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all top-level function groups (GV, ID, PR, DE, RS, RC) from the resolved NIST CSF 2.0 catalog. Resolved catalogs are created from profiles and contain tailored controls.
     * Get all functions from resolved catalog
     */
    async getAllFunctionsResolved(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.getAllFunctionsResolvedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all control IDs that are already assessed in existing assessments for a System Security Plan. This is used to filter out controls when creating a new assessment to prevent duplicate assessments.
     * Get assessed control IDs for SSP
     */
    async getAssessedControlIdsRaw(requestParameters: GetAssessedControlIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Set<string>>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getAssessedControlIds().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/assessed-controls`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Retrieves all control IDs that are already assessed in existing assessments for a System Security Plan. This is used to filter out controls when creating a new assessment to prevent duplicate assessments.
     * Get assessed control IDs for SSP
     */
    async getAssessedControlIds(requestParameters: GetAssessedControlIdsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Set<string>> {
        const response = await this.getAssessedControlIdsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves an AssessmentResults document by its UUID. Includes all results with their CMMI maturity levels.
     * Get assessment by ID
     */
    async getAssessmentByIdRaw(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling getAssessmentById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentResultResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves an AssessmentResults document by its UUID. Includes all results with their CMMI maturity levels.
     * Get assessment by ID
     */
    async getAssessmentById(requestParameters: GetAssessmentByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse> {
        const response = await this.getAssessmentByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the AssessmentResults document for a System Security Plan. Includes all results with their CMMI maturity levels.
     * Get assessment for SSP
     */
    async getAssessmentBySSPIdRaw(requestParameters: GetAssessmentBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getAssessmentBySSPId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/assessment`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentResultResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the AssessmentResults document for a System Security Plan. Includes all results with their CMMI maturity levels.
     * Get assessment for SSP
     */
    async getAssessmentBySSPId(requestParameters: GetAssessmentBySSPIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse> {
        const response = await this.getAssessmentBySSPIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Percentage of control results with a maturity set (0-100).
     * Get assessment progress
     */
    async getAssessmentProgressRaw(requestParameters: GetAssessmentProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentProgressResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getAssessmentProgress().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/assessment-progress`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentProgressResponseFromJSON(jsonValue));
    }

    /**
     * Percentage of control results with a maturity set (0-100).
     * Get assessment progress
     */
    async getAssessmentProgress(requestParameters: GetAssessmentProgressRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentProgressResponse> {
        const response = await this.getAssessmentProgressRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lightweight list of assessments (id, name) for the Assessment dropdown.
     * Get assessments summary for dashboard filter
     */
    async getAssessmentsSummaryRaw(requestParameters: GetAssessmentsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentSummaryResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getAssessmentsSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentIds'] != null) {
            queryParameters['assessmentIds'] = requestParameters['assessmentIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/assessments/summary`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Lightweight list of assessments (id, name) for the Assessment dropdown.
     * Get assessments summary for dashboard filter
     */
    async getAssessmentsSummary(requestParameters: GetAssessmentsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentSummaryResponse> {
        const response = await this.getAssessmentsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the full base NIST CSF 2.0 catalog structure (groups and controls) with flags indicating which items were selected in the resolved catalog built from the specified profile.
     * Get base catalog with selection indicators
     */
    async getBaseCatalogWithSelectionsRaw(requestParameters: GetBaseCatalogWithSelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CatalogComparisonResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getBaseCatalogWithSelections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/profile/{profileId}/base-catalog`;
        urlPath = urlPath.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CatalogComparisonResponseFromJSON(jsonValue));
    }

    /**
     * Returns the full base NIST CSF 2.0 catalog structure (groups and controls) with flags indicating which items were selected in the resolved catalog built from the specified profile.
     * Get base catalog with selection indicators
     */
    async getBaseCatalogWithSelections(requestParameters: GetBaseCatalogWithSelectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CatalogComparisonResponse> {
        const response = await this.getBaseCatalogWithSelectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Total budget from POAMs and total allocated from POAM item milestones.
     * Get budget summary
     */
    async getBudgetSummaryRaw(requestParameters: GetBudgetSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<BudgetSummaryResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getBudgetSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/budget-summary`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => BudgetSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Total budget from POAMs and total allocated from POAM item milestones.
     * Get budget summary
     */
    async getBudgetSummary(requestParameters: GetBudgetSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<BudgetSummaryResponse> {
        const response = await this.getBudgetSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function
     * Get categories for a function
     */
    async getCategoriesByFunctionIdRaw(requestParameters: GetCategoriesByFunctionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling getCategoriesByFunctionId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/functions/{functionId}/categories`;
        urlPath = urlPath.replace(`{${"functionId"}}`, encodeURIComponent(String(requestParameters['functionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function
     * Get categories for a function
     */
    async getCategoriesByFunctionId(requestParameters: GetCategoriesByFunctionIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.getCategoriesByFunctionIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. Includes control counts for each category.
     * Get categories for a function from SSP
     */
    async getCategoriesByFunctionIdForSSPRaw(requestParameters: GetCategoriesByFunctionIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListWithCountsResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getCategoriesByFunctionIdForSSP().'
            );
        }

        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling getCategoriesByFunctionIdForSSP().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/functions/{functionId}/categories`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));
        urlPath = urlPath.replace(`{${"functionId"}}`, encodeURIComponent(String(requestParameters['functionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListWithCountsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. Includes control counts for each category.
     * Get categories for a function from SSP
     */
    async getCategoriesByFunctionIdForSSP(requestParameters: GetCategoriesByFunctionIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListWithCountsResponse> {
        const response = await this.getCategoriesByFunctionIdForSSPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved NIST CSF 2.0 catalog. Includes control counts for each category.
     * Get categories for a function from resolved catalog with control counts
     */
    async getCategoriesByFunctionIdResolvedWithCountsRaw(requestParameters: GetCategoriesByFunctionIdResolvedWithCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListWithCountsResponse>> {
        if (requestParameters['functionId'] == null) {
            throw new runtime.RequiredError(
                'functionId',
                'Required parameter "functionId" was null or undefined when calling getCategoriesByFunctionIdResolvedWithCounts().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/functions/{functionId}/categories`;
        urlPath = urlPath.replace(`{${"functionId"}}`, encodeURIComponent(String(requestParameters['functionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListWithCountsResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves all categories (sub-groups) for a specific function from the resolved NIST CSF 2.0 catalog. Includes control counts for each category.
     * Get categories for a function from resolved catalog with control counts
     */
    async getCategoriesByFunctionIdResolvedWithCounts(requestParameters: GetCategoriesByFunctionIdResolvedWithCountsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListWithCountsResponse> {
        const response = await this.getCategoriesByFunctionIdResolvedWithCountsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\')
     * Get control by control ID
     */
    async getControlByControlIdRaw(requestParameters: GetControlByControlIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>> {
        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling getControlByControlId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/controls/{controlId}`;
        urlPath = urlPath.replace(`{${"controlId"}}`, encodeURIComponent(String(requestParameters['controlId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\')
     * Get control by control ID
     */
    async getControlByControlId(requestParameters: GetControlByControlIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse> {
        const response = await this.getControlByControlIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific control by its control ID from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. This ensures the correct control is returned even if the same controlId exists in multiple catalogs.
     * Get control by control ID from SSP
     */
    async getControlByControlIdForSSPRaw(requestParameters: GetControlByControlIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getControlByControlIdForSSP().'
            );
        }

        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling getControlByControlIdForSSP().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/controls/{controlId}`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));
        urlPath = urlPath.replace(`{${"controlId"}}`, encodeURIComponent(String(requestParameters['controlId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific control by its control ID from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id. This ensures the correct control is returned even if the same controlId exists in multiple catalogs.
     * Get control by control ID from SSP
     */
    async getControlByControlIdForSSP(requestParameters: GetControlByControlIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse> {
        const response = await this.getControlByControlIdForSSPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\') from the resolved NIST CSF 2.0 catalog. The control must belong to a resolved catalog.
     * Get control by control ID from resolved catalog
     */
    async getControlByControlIdResolvedRaw(requestParameters: GetControlByControlIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlResponse>> {
        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling getControlByControlIdResolved().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/controls/{controlId}`;
        urlPath = urlPath.replace(`{${"controlId"}}`, encodeURIComponent(String(requestParameters['controlId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific control by its control ID (e.g., \'gv.oc-1\') from the resolved NIST CSF 2.0 catalog. The control must belong to a resolved catalog.
     * Get control by control ID from resolved catalog
     */
    async getControlByControlIdResolved(requestParameters: GetControlByControlIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlResponse> {
        const response = await this.getControlByControlIdResolvedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated controls for a specific group
     * Get controls for a group
     */
    async getControlsByGroupIdRaw(requestParameters: GetControlsByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getControlsByGroupId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/groups/{groupId}/controls`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated controls for a specific group
     * Get controls for a group
     */
    async getControlsByGroupId(requestParameters: GetControlsByGroupIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse> {
        const response = await this.getControlsByGroupIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated controls for a specific group from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id.
     * Get controls for a group from SSP
     */
    async getControlsByGroupIdForSSPRaw(requestParameters: GetControlsByGroupIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getControlsByGroupIdForSSP().'
            );
        }

        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getControlsByGroupIdForSSP().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/groups/{groupId}/controls`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated controls for a specific group from the resolved catalog used by the System Security Plan. The resolved catalog is determined from the SSP\'s import_profile_id.
     * Get controls for a group from SSP
     */
    async getControlsByGroupIdForSSP(requestParameters: GetControlsByGroupIdForSSPRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse> {
        const response = await this.getControlsByGroupIdForSSPRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated controls for a specific group from the resolved NIST CSF 2.0 catalog. The group must belong to a resolved catalog.
     * Get controls for a group from resolved catalog
     */
    async getControlsByGroupIdResolvedRaw(requestParameters: GetControlsByGroupIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ControlListResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getControlsByGroupIdResolved().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/groups/{groupId}/controls`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ControlListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated controls for a specific group from the resolved NIST CSF 2.0 catalog. The group must belong to a resolved catalog.
     * Get controls for a group from resolved catalog
     */
    async getControlsByGroupIdResolved(requestParameters: GetControlsByGroupIdResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ControlListResponse> {
        const response = await this.getControlsByGroupIdResolvedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves controls for an SSP grouped by function and category, paginated by function. Each page returns one or more functions with all their categories and controls from the SSP\'s resolved catalog.
     * Get controls grouped by function and category for SSP
     */
    async getControlsGroupedByFunctionCategoryRaw(requestParameters: GetControlsGroupedByFunctionCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SspControlsGroupedResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getControlsGroupedByFunctionCategory().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/controls-by-function-category`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SspControlsGroupedResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves controls for an SSP grouped by function and category, paginated by function. Each page returns one or more functions with all their categories and controls from the SSP\'s resolved catalog.
     * Get controls grouped by function and category for SSP
     */
    async getControlsGroupedByFunctionCategory(requestParameters: GetControlsGroupedByFunctionCategoryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SspControlsGroupedResponse> {
        const response = await this.getControlsGroupedByFunctionCategoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Counts of satisfied and not-satisfied findings in scoped results.
     * Get findings summary
     */
    async getFindingsSummaryRaw(requestParameters: GetFindingsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FindingsSummaryResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getFindingsSummary().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/findings-summary`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingsSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Counts of satisfied and not-satisfied findings in scoped results.
     * Get findings summary
     */
    async getFindingsSummary(requestParameters: GetFindingsSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FindingsSummaryResponse> {
        const response = await this.getFindingsSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Maturity and progress per CSF function (GV, ID, PR, DE, RS, RC) for overview cards and spider chart.
     * Get function maturity
     */
    async getFunctionMaturityRaw(requestParameters: GetFunctionMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FunctionMaturityResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getFunctionMaturity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/function-maturity`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FunctionMaturityResponseFromJSON(jsonValue));
    }

    /**
     * Maturity and progress per CSF function (GV, ID, PR, DE, RS, RC) for overview cards and spider chart.
     * Get function maturity
     */
    async getFunctionMaturity(requestParameters: GetFunctionMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FunctionMaturityResponse> {
        const response = await this.getFunctionMaturityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific group with its basic details
     * Get group details
     */
    async getGroupByIdRaw(requestParameters: GetGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/groups/{groupId}`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific group with its basic details
     * Get group details
     */
    async getGroupById(requestParameters: GetGroupByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.getGroupByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a group with its full hierarchy including sub-groups and controls
     * Get group hierarchy
     */
    async getGroupHierarchyRaw(requestParameters: GetGroupHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupResponse>> {
        if (requestParameters['groupId'] == null) {
            throw new runtime.RequiredError(
                'groupId',
                'Required parameter "groupId" was null or undefined when calling getGroupHierarchy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/groups/{groupId}/hierarchy`;
        urlPath = urlPath.replace(`{${"groupId"}}`, encodeURIComponent(String(requestParameters['groupId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a group with its full hierarchy including sub-groups and controls
     * Get group hierarchy
     */
    async getGroupHierarchy(requestParameters: GetGroupHierarchyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupResponse> {
        const response = await this.getGroupHierarchyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * All dashboard widget data in one response.
     * Get combined dashboard
     */
    async getNistCsfDashboardRaw(requestParameters: GetNistCsfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DashboardResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getNistCsfDashboard().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DashboardResponseFromJSON(jsonValue));
    }

    /**
     * All dashboard widget data in one response.
     * Get combined dashboard
     */
    async getNistCsfDashboard(requestParameters: GetNistCsfDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DashboardResponse> {
        const response = await this.getNistCsfDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Average current maturity (1-5) across scoped assessment results.
     * Get overall maturity
     */
    async getOverallMaturityRaw(requestParameters: GetOverallMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OverallMaturityResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getOverallMaturity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/overall-maturity`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OverallMaturityResponseFromJSON(jsonValue));
    }

    /**
     * Average current maturity (1-5) across scoped assessment results.
     * Get overall maturity
     */
    async getOverallMaturity(requestParameters: GetOverallMaturityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OverallMaturityResponse> {
        const response = await this.getOverallMaturityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a specific profile by its UUID that imports the NIST CSF 2.0 BASE catalog.
     * Get NIST CSF profile by ID
     */
    async getProfileById1Raw(requestParameters: GetProfileById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileDto>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getProfileById1().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/profile/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileDtoFromJSON(jsonValue));
    }

    /**
     * Retrieves a specific profile by its UUID that imports the NIST CSF 2.0 BASE catalog.
     * Get NIST CSF profile by ID
     */
    async getProfileById1(requestParameters: GetProfileById1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileDto> {
        const response = await this.getProfileById1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a paginated list of all profiles that import the NIST CSF 2.0 BASE catalog.
     * Get all NIST CSF profiles
     */
    async getProfilesRaw(requestParameters: GetProfilesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileListResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/profiles`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileListResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a paginated list of all profiles that import the NIST CSF 2.0 BASE catalog.
     * Get all NIST CSF profiles
     */
    async getProfiles(requestParameters: GetProfilesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileListResponse> {
        const response = await this.getProfilesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Merged assessment and POAM events for this SSP, sorted by date descending.
     * Get recent activity
     */
    async getRecentActivityRaw(requestParameters: GetRecentActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RecentActivityResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getRecentActivity().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assessmentId'] != null) {
            queryParameters['assessmentId'] = requestParameters['assessmentId'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/recent-activity`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RecentActivityResponseFromJSON(jsonValue));
    }

    /**
     * Merged assessment and POAM events for this SSP, sorted by date descending.
     * Get recent activity
     */
    async getRecentActivity(requestParameters: GetRecentActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RecentActivityResponse> {
        const response = await this.getRecentActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Open POAM count and overdue POAM item count for this SSP.
     * Get remediation summary
     */
    async getRemediationSummaryRaw(requestParameters: GetRemediationSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<RemediationSummaryResponse>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getRemediationSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/dashboard/remediation-summary`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => RemediationSummaryResponseFromJSON(jsonValue));
    }

    /**
     * Open POAM count and overdue POAM item count for this SSP.
     * Get remediation summary
     */
    async getRemediationSummary(requestParameters: GetRemediationSummaryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<RemediationSummaryResponse> {
        const response = await this.getRemediationSummaryRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the System Security Plan ID and assessment IDs associated with a profile. This provides a direct way to get the SSP ID without re-resolving the profile.
     * Get SSP and assessments for profile
     */
    async getSSPForProfileRaw(requestParameters: GetSSPForProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileSSPResponse>> {
        if (requestParameters['profileId'] == null) {
            throw new runtime.RequiredError(
                'profileId',
                'Required parameter "profileId" was null or undefined when calling getSSPForProfile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/profile/{profileId}/ssp`;
        urlPath = urlPath.replace(`{${"profileId"}}`, encodeURIComponent(String(requestParameters['profileId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileSSPResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the System Security Plan ID and assessment IDs associated with a profile. This provides a direct way to get the SSP ID without re-resolving the profile.
     * Get SSP and assessments for profile
     */
    async getSSPForProfile(requestParameters: GetSSPForProfileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileSSPResponse> {
        const response = await this.getSSPForProfileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the statement description for a control in an SSP\'s ImplementedRequirement.
     * Get statement for control in SSP
     */
    async getStatementForControlRaw(requestParameters: GetStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<string>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling getStatementForControl().'
            );
        }

        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling getStatementForControl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/controls/{controlId}/statement`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));
        urlPath = urlPath.replace(`{${"controlId"}}`, encodeURIComponent(String(requestParameters['controlId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (this.isJsonMime(response.headers.get('content-type'))) {
            return new runtime.JSONApiResponse<string>(response);
        } else {
            return new runtime.TextApiResponse(response) as any;
        }
    }

    /**
     * Retrieves the statement description for a control in an SSP\'s ImplementedRequirement.
     * Get statement for control in SSP
     */
    async getStatementForControl(requestParameters: GetStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<string> {
        const response = await this.getStatementForControlRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Returns the full NIST CSF 2.0 BASE catalog as nested functions, categories, and slim control rows (id, controlId, title, targetMaturity) in one response. Replaces many parallel calls to functions, categories, and per-group controls for the wizard.
     * Get BASE catalog tree for create/tailor wizard
     */
    async getWizardBaseCatalogTreeRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<NistCsfWizardCatalogTreeResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/wizard/catalog-tree`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => NistCsfWizardCatalogTreeResponseFromJSON(jsonValue));
    }

    /**
     * Returns the full NIST CSF 2.0 BASE catalog as nested functions, categories, and slim control rows (id, controlId, title, targetMaturity) in one response. Replaces many parallel calls to functions, categories, and per-group controls for the wizard.
     * Get BASE catalog tree for create/tailor wizard
     */
    async getWizardBaseCatalogTree(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<NistCsfWizardCatalogTreeResponse> {
        const response = await this.getWizardBaseCatalogTreeRaw(initOverrides);
        return await response.value();
    }

    /**
     * Resolves a NIST CSF profile to generate a resolved catalog. The resolved catalog contains tailored controls based on the profile\'s selections, exclusions, and modifications.
     * Resolve profile to catalog
     */
    async resolveProfile1Raw(requestParameters: ResolveProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ProfileResolutionResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling resolveProfile1().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resolvedBy'] != null) {
            queryParameters['resolvedBy'] = requestParameters['resolvedBy'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/profile/{id}/create`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ProfileResolutionResponseFromJSON(jsonValue));
    }

    /**
     * Resolves a NIST CSF profile to generate a resolved catalog. The resolved catalog contains tailored controls based on the profile\'s selections, exclusions, and modifications.
     * Resolve profile to catalog
     */
    async resolveProfile1(requestParameters: ResolveProfile1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ProfileResolutionResponse> {
        const response = await this.resolveProfile1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches groups by title or description with pagination
     * Search groups
     */
    async searchGroupsRaw(requestParameters: SearchGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchGroups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/search/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Searches groups by title or description with pagination
     * Search groups
     */
    async searchGroups(requestParameters: SearchGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.searchGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches groups by title or description with pagination in the resolved NIST CSF 2.0 catalog. Resolved catalogs contain controls that have been tailored and customized from profiles.
     * Search groups in resolved catalog
     */
    async searchGroupsResolvedRaw(requestParameters: SearchGroupsResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GroupListResponse>> {
        if (requestParameters['q'] == null) {
            throw new runtime.RequiredError(
                'q',
                'Required parameter "q" was null or undefined when calling searchGroupsResolved().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['q'] != null) {
            queryParameters['q'] = requestParameters['q'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/compliance/nist-csf/resolved/search/groups`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GroupListResponseFromJSON(jsonValue));
    }

    /**
     * Searches groups by title or description with pagination in the resolved NIST CSF 2.0 catalog. Resolved catalogs contain controls that have been tailored and customized from profiles.
     * Search groups in resolved catalog
     */
    async searchGroupsResolved(requestParameters: SearchGroupsResolvedRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GroupListResponse> {
        const response = await this.searchGroupsResolvedRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds new controls to an existing assessment. Can add specific controls or all controls in specified groups (recursively). Controls that are already in the assessment will be skipped.
     * Update assessment to add controls
     */
    async updateAssessmentRaw(requestParameters: UpdateAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssessmentResultResponse>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling updateAssessment().'
            );
        }

        if (requestParameters['assessmentUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'assessmentUpdateRequest',
                'Required parameter "assessmentUpdateRequest" was null or undefined when calling updateAssessment().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: AssessmentUpdateRequestToJSON(requestParameters['assessmentUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssessmentResultResponseFromJSON(jsonValue));
    }

    /**
     * Adds new controls to an existing assessment. Can add specific controls or all controls in specified groups (recursively). Controls that are already in the assessment will be skipped.
     * Update assessment to add controls
     */
    async updateAssessment(requestParameters: UpdateAssessmentRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssessmentResultResponse> {
        const response = await this.updateAssessmentRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the current CMMI maturity level for a specific assessment result. Target maturity is defined on the catalog control. CMMI maturity values must be integers between 1 and 5 (inclusive).
     * Update result properties
     */
    async updateResultPropertiesRaw(requestParameters: UpdateResultPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultResponse>> {
        if (requestParameters['assessmentId'] == null) {
            throw new runtime.RequiredError(
                'assessmentId',
                'Required parameter "assessmentId" was null or undefined when calling updateResultProperties().'
            );
        }

        if (requestParameters['resultId'] == null) {
            throw new runtime.RequiredError(
                'resultId',
                'Required parameter "resultId" was null or undefined when calling updateResultProperties().'
            );
        }

        if (requestParameters['resultUpdateRequest'] == null) {
            throw new runtime.RequiredError(
                'resultUpdateRequest',
                'Required parameter "resultUpdateRequest" was null or undefined when calling updateResultProperties().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/assessment/{assessmentId}/result/{resultId}`;
        urlPath = urlPath.replace(`{${"assessmentId"}}`, encodeURIComponent(String(requestParameters['assessmentId'])));
        urlPath = urlPath.replace(`{${"resultId"}}`, encodeURIComponent(String(requestParameters['resultId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ResultUpdateRequestToJSON(requestParameters['resultUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultResponseFromJSON(jsonValue));
    }

    /**
     * Updates the current CMMI maturity level for a specific assessment result. Target maturity is defined on the catalog control. CMMI maturity values must be integers between 1 and 5 (inclusive).
     * Update result properties
     */
    async updateResultProperties(requestParameters: UpdateResultPropertiesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultResponse> {
        const response = await this.updateResultPropertiesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the statement description for a control in an SSP\'s ImplementedRequirement. Creates the ImplementedRequirement and Statement if they don\'t exist.
     * Update statement for control in SSP
     */
    async updateStatementForControlRaw(requestParameters: UpdateStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['sspId'] == null) {
            throw new runtime.RequiredError(
                'sspId',
                'Required parameter "sspId" was null or undefined when calling updateStatementForControl().'
            );
        }

        if (requestParameters['controlId'] == null) {
            throw new runtime.RequiredError(
                'controlId',
                'Required parameter "controlId" was null or undefined when calling updateStatementForControl().'
            );
        }

        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling updateStatementForControl().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/compliance/nist-csf/ssp/{sspId}/controls/{controlId}/statement`;
        urlPath = urlPath.replace(`{${"sspId"}}`, encodeURIComponent(String(requestParameters['sspId'])));
        urlPath = urlPath.replace(`{${"controlId"}}`, encodeURIComponent(String(requestParameters['controlId'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Updates the statement description for a control in an SSP\'s ImplementedRequirement. Creates the ImplementedRequirement and Statement if they don\'t exist.
     * Update statement for control in SSP
     */
    async updateStatementForControl(requestParameters: UpdateStatementForControlRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStatementForControlRaw(requestParameters, initOverrides);
    }

}
